import { PayloadAction } from "@reduxjs/toolkit";
import { ActionPromptType } from "./action-prompt-type";
import { IRequestState } from "../request.state.interface";
import { LoginResponse } from "../user/login.handler";
import { formActionPrompts } from "./complete-action-prompt.handler";

interface IActionPromptsState extends IRequestState {
    items: ActionPromptType[];
}

export const loginFulfilledForActionPromptsHandler = (state: IActionPromptsState, action: PayloadAction<LoginResponse>) => {
    if (!action.payload?.user?.actionPrompts)
        return;

    state.items = formActionPrompts(action.payload.user.actionPrompts);
};
